// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import tenantReducer from './slices/tenantSlice';

export const store = configureStore({
  reducer: {
    tenants: tenantReducer,
  },
});

export default store;